<template>
  <div id="jbrowse">
    <b-container v-if="authenticated">
      <h2>Jbrowse links</h2>
      <h4>Click on an organism to visit its Jbrowse page</h4>
      <Tree :data="tree_data" :item-events="itemEvents" />
      <b-alert
        dismissible
        :show="dismissCountDown"
        variant="danger"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
        >{{ errorMessage }}</b-alert
      >
    </b-container>
    <b-alert v-else show variant="danger">You must be logged to access this function</b-alert>
  </div>
</template>

<script>
import Tree from '@/components/Tree.vue';
import Vue from 'vue';

export default {
  name: 'Jbrowse',
  components: {
    Tree,
  },
  data() {
    var component = this;
    return {
      errorMessage: 'Error',
      dismissSecs: 3,
      dismissCountDown: 0,
      itemEvents: {
        click: function() {
          var idSpecies = arguments[1].id;
          Vue.http.post('api/jbrowse', { id_species: idSpecies }).then(
            resp => {
              if (resp.body.success === false) {
                component.errorMessage = resp.body.message;
                component.showAlert();
              } else {
                window.open(resp.body.message);
              }
            },
            () => {
              component.errorMessage = 'Server error';
              component.showAlert();
            }
          );
        },
      },
    };
  },

  computed: {
    tree_data: function() {
      return this.$store.getters.getTreeData;
    },
    authenticated: function() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
  },
};
</script>
<style scoped>
#jbrowse {
  margin: 25px;
}
</style>
